import { render, staticRenderFns } from "./ChangeQuotationPriority.vue?vue&type=template&id=89dac99a&scoped=true"
import script from "./ChangeQuotationPriority.vue?vue&type=script&lang=js"
export * from "./ChangeQuotationPriority.vue?vue&type=script&lang=js"
import style0 from "./ChangeQuotationPriority.vue?vue&type=style&index=0&id=89dac99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dac99a",
  null
  
)

export default component.exports